<template>
  <div id="imageContainer" ref="imageContainer">
    <loading v-show="loadingActive"></loading>
    <img ref="viewerDom" src="" alt="" class="imageClass" @load="imageLoad" />
    <div style="z-index:99999" class="returnfsty" @click="returnf">
      <p id="goBack">返回</p>
    </div>
  </div>
</template>

<script>
import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";
import { scanUrlapp } from "@/CommonDP/utils";
import loading from "@/CommonDP/components/loading/loading.vue";
export default {
  components: {
    loading
  },
  data() {
    return {
      loadingActive: true,
      urlSrc: ""
    };
  },

  async mounted() {
    const { f, n } = this.$route.query;
    document.title = n;
    const imageSrc = scanUrlapp(f);
    this.$refs.viewerDom.src = imageSrc;
    this.initEvent();
  },

  methods: {
    returnf() {
      // do nothing
    },
    initEvent() {
      console.log("初始化监听事件");
      document.addEventListener("touchstart", this.touch2mouse, true);
      document.addEventListener("touchmove", this.touch2mouse, true);
      document.addEventListener("touchend", this.touch2mouse, true);
    },

    touch2mouse(event) {
      var touches = event.changedTouches;
      var first = touches[0];
      var type = "";
      switch (event.type) {
        case "touchstart":
          type = "mousedown";
          break;
        case "touchmove":
          type = "mousemove";
          break;
        case "touchend":
          type = "mouseup";
          break;
        default:
          return;
      }

      var simulatedEvent = document.createEvent("MouseEvent");
      simulatedEvent.initMouseEvent(
        type,
        true,
        true,
        window,
        1,
        first.screenX,
        first.screenY,
        first.clientX,
        first.clientY,
        false,
        false,
        false,
        false,
        0 /* left*/,
        null
      );
      first.target.dispatchEvent(simulatedEvent);
    },

    imageLoad() {
      this.loadingActive = false;
      const imageDom = this.$refs.viewerDom;
      this.viewer = new Viewer(imageDom, {
        initialViewIndex: 0,
        button: true,
        navbar: false,
        title: 0,
        toolbar: 0,
        keyboard: true,
        zIndex: 0
      });
      imageDom.click();
    }
  },

  beforeRouteLeave(to, form, next) {
    this.viewer.destroy();
    next();
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
#imageContainer {
  width: 100%;
  height: 100%;

  .imageClass {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    width: 50%;
    height: 50%;
    display: none;
  }

  .returnfsty {
    line-height: 48px;
    height: 48px;
    text-align: center;
    background: #fff;
    font-size: 16px;
    color: #616161;
    cursor: pointer;
    position: absolute;
    z-index: 9;
    left: 0;
    right: 0;
    bottom: 0;
  }
}
</style>
